<template>
  <v-app-bar
    v-if="showAppbarAndDrawer()"
    id="app-bar"
    color="black"
    flat
    app
    height="65"
  >
    <v-icon
      class="mr-2"
      color="white"
      @click="setDrawer(!drawer)"
    >
      mdi-menu
    </v-icon>
    <v-btn
      class="ma-0 pa-0"
      text
      @click="$router.push('/app')"
    >
      <v-icon
        size="46"
        color="success"
      >
        mdi-certificate-outline
      </v-icon>
      <span class="font-weight-bold text-h4 white--text ml-2">
        資格管理アプリ
      </span>
    </v-btn>
    <v-spacer />
    <!--
    <v-switch
      v-model="$vuetify.theme.dark"
      class="mt-5"
      color="primary"
    />
    -->
    <!-- プレビューダイアログ -->
    <v-dialog v-model="previewDialog" max-width="520">
      <v-card>
        <v-card-title class="text-subtitle-1 font-weight-bold">
          <v-icon class="mr-2" small>mdi-eye</v-icon>
          公開プロフィール プレビュー
          <v-spacer />
          <v-btn icon small @click="previewDialog = false"><v-icon small>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider />
        <v-card-text class="pa-4">
          <div class="text-center mb-4">
            <v-icon size="40" color="primary">mdi-certificate-outline</v-icon>
            <div class="text-h6 font-weight-bold mt-2">資格ポートフォリオ</div>
            <div class="d-flex justify-center mt-2" style="gap: 8px;">
              <v-chip x-small color="primary" outlined>取得済み {{ previewAcquired.length }}件</v-chip>
              <v-chip x-small color="secondary" outlined>勉強中 {{ previewStudying.length }}件</v-chip>
            </div>
          </div>
          <template v-if="previewAcquired.length">
            <div class="caption font-weight-bold grey--text text--darken-2 mb-2">
              <v-icon x-small color="primary" class="mr-1">mdi-badge-account-horizontal</v-icon>取得済み
            </div>
            <v-card flat outlined class="mb-3 rounded">
              <v-list dense>
                <template v-for="(item, i) in previewAcquired">
                  <v-divider v-if="i > 0" :key="`d${i}`" />
                  <v-list-item :key="i" dense>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 font-weight-bold">{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.shutokubi" class="caption">取得日: {{ item.shutokubi }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </template>
          <template v-if="previewStudying.length">
            <div class="caption font-weight-bold grey--text text--darken-2 mb-2">
              <v-icon x-small color="secondary" class="mr-1">mdi-book-open-variant</v-icon>勉強中
            </div>
            <v-card flat outlined class="mb-3 rounded">
              <v-list dense>
                <template v-for="(item, i) in previewStudying">
                  <v-divider v-if="i > 0" :key="`d${i}`" />
                  <v-list-item :key="i" dense>
                    <v-list-item-content>
                      <v-list-item-title class="body-2 font-weight-bold">{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.shikenbi" class="caption">試験日: {{ item.shikenbi }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </template>
          <div v-if="!previewAcquired.length && !previewStudying.length" class="text-center grey--text py-4">
            公開する資格が選択されていません
          </div>
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn text @click="previewDialog = false">閉じる</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 公開プロフィール設定モーダル -->
    <v-dialog v-model="publicProfileDialog" max-width="480" scrollable>
      <v-card>
        <v-card-title class="text-h6 font-weight-bold">
          <v-icon class="mr-2">mdi-earth</v-icon>
          公開プロフィール
          <v-spacer />
          <v-chip v-if="publicToken" x-small color="success">公開中</v-chip>
        </v-card-title>
        <v-divider />

        <!-- URL表示エリア（公開中のみ） -->
        <v-card-text v-if="publicToken" class="pb-0 pt-3">
          <v-text-field
            :value="publicUrl"
            readonly
            outlined
            dense
            hide-details
            class="mb-2"
          >
            <template v-slot:append>
              <v-btn icon small @click="copyUrl">
                <v-icon small>{{ copied ? 'mdi-check' : 'mdi-content-copy' }}</v-icon>
              </v-btn>
            </template>
          </v-text-field>
          <v-btn outlined color="primary" small :href="publicUrl" target="_blank" class="mb-1">
            <v-icon small left>mdi-open-in-new</v-icon>開く
          </v-btn>
        </v-card-text>

        <v-divider v-if="publicToken" class="mt-3" />

        <!-- 資格選択エリア -->
        <v-card-text class="pt-3" style="max-height: 400px; overflow-y: auto;">
          <div class="caption grey--text mb-3">公開する資格を選択してください</div>

          <!-- 取得済み -->
          <template v-if="$store.state.user.shikakuList && $store.state.user.shikakuList.length">
            <div class="caption font-weight-bold grey--text text--darken-2 mb-1">
              <v-icon x-small color="primary" class="mr-1">mdi-badge-account-horizontal</v-icon>取得済み
            </div>
            <v-card flat outlined class="mb-3 rounded">
              <v-list dense>
                <template v-for="(item, i) in $store.state.user.shikakuList">
                  <v-divider v-if="i > 0" :key="`da${i}`" />
                  <v-list-item :key="`a${i}`" dense @click="toggleAcquired(item.id)">
                    <v-list-item-action class="mr-2 my-0">
                      <v-checkbox
                        :input-value="selectedAcquiredIds.includes(item.id)"
                        color="primary"
                        dense
                        hide-details
                        readonly
                      />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.shutokubi" class="caption">{{ item.shutokubi }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </template>

          <!-- 勉強中 -->
          <template v-if="$store.state.user.studyList && $store.state.user.studyList.length">
            <div class="caption font-weight-bold grey--text text--darken-2 mb-1">
              <v-icon x-small color="secondary" class="mr-1">mdi-book-open-variant</v-icon>勉強中
            </div>
            <v-card flat outlined class="mb-3 rounded">
              <v-list dense>
                <template v-for="(item, i) in $store.state.user.studyList">
                  <v-divider v-if="i > 0" :key="`ds${i}`" />
                  <v-list-item :key="`s${i}`" dense @click="toggleStudying(item.id)">
                    <v-list-item-action class="mr-2 my-0">
                      <v-checkbox
                        :input-value="selectedStudyingIds.includes(item.id)"
                        color="secondary"
                        dense
                        hide-details
                        readonly
                      />
                    </v-list-item-action>
                    <v-list-item-content>
                      <v-list-item-title class="body-2">{{ item.name }}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.shikenbi" class="caption">{{ item.shikenbi }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </template>

          <div v-if="!$store.state.user.shikakuList.length && !$store.state.user.studyList.length" class="text-center grey--text py-4">
            公開できる資格がありません
          </div>
        </v-card-text>

        <v-divider />
        <v-card-actions>
          <v-btn text small @click="previewDialog = true">
            <v-icon small left>mdi-eye</v-icon>プレビュー
          </v-btn>
          <v-spacer />
          <v-btn v-if="publicToken" text color="error" small :loading="publicLoading" @click="disablePublicProfile">
            非公開にする
          </v-btn>
          <v-btn depressed color="primary" small :loading="publicLoading" @click="enablePublicProfile">
            {{ publicToken ? '更新する' : '公開する' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-menu
      :open-on-click="true"
      :close-on-content-click="false"
      bottom
      left
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          size="40"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon
            dark
            large
          >
            mdi-account-circle
          </v-icon>
          <!--
          <v-img
            :src="$store.state.user.photoURL"
            alt="Icon"
          />
          -->
        </v-avatar>
      </template>
      <v-list>
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-account</v-icon>
          </v-list-item-icon>
          <!--
          <v-list-item-icon>
            <v-img
              height="36"
              width="36"
              :src="$store.state.user.photoURL"
              alt="Icon"
            />
          </v-list-item-icon>
          -->
          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ $store.state.user.displayName }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-divider />
      <v-list>
        <v-list-item @click="publicProfileDialog = true">
          <v-list-item-icon>
            <v-icon>mdi-earth</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              公開プロフィール
            </v-list-item-title>
          </v-list-item-content>
          <v-list-item-action v-if="publicToken">
            <v-icon small color="success">mdi-circle</v-icon>
          </v-list-item-action>
        </v-list-item>
        <v-list-item @click="changeTheme()">
          <v-list-item-icon>
            <v-icon>mdi-theme-light-dark</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              テーマ
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="syncAppData()">
          <v-list-item-icon>
            <v-icon>mdi-sync</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              更新
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/privacy')">
          <v-list-item-icon>
            <v-icon>mdi-lock-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              プライバシーポリシー
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="$router.push('/terms')">
          <v-list-item-icon>
            <v-icon>mdi-scale-balance</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              著作権・免責事項
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          target="_blank"
          href="https://note.com/shikakukanri/n/n7ce1be0171e1"
        >
          <v-list-item-icon>
            <v-icon>mdi-note-text-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              リリースノート
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          target="_blank"
          href="https://docs.google.com/forms/d/e/1FAIpQLSdJmY7OY-XygopaKBjKrPIDHXqErFxHbtEVY_nzCKGotMuCUA/viewform"
        >
          <v-list-item-icon>
            <v-icon>mdi-chat-processing-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              お問い合わせ
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item @click="logout()">
          <v-list-item-icon>
            <v-icon>mdi-logout</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              ログアウト
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-divider />
        <v-list-item>
          <v-list-item-icon>
            <v-icon>mdi-source-branch</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>
              Version: {{ version }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
  import firebase from 'firebase'
  import { v4 as uuidv4 } from 'uuid'
  import versionData from '../../../../../version.md'
  import showAppbarAndDrawer from '../../mixin/common'
  import { funcSetDataToFirebase, funcGetPublicProfile, funcSetPublicProfile, funcDeletePublicProfile } from '../../../../functions/fb-modules'
  import { mapState, mapMutations } from 'vuex'
  import { BASE_URL } from '../../../../parameter'
  export default {
    name: 'DashboardCoreAppBar',
    mixins: [
      showAppbarAndDrawer,
    ],
    data: () => ({
      publicProfileDialog: false,
      publicToken: null,
      publicLoading: false,
      copied: false,
      previewDialog: false,
      selectedAcquiredIds: [],
      selectedStudyingIds: [],
    }),
    async created () {
      const uid = this.$store.state.user.uid
      if (!uid) return
      const savedToken = localStorage.getItem(`publicProfileToken_${uid}`)
      if (savedToken) {
        const profile = await funcGetPublicProfile(savedToken)
        if (profile) {
          this.publicToken = savedToken
          const savedAcquired = localStorage.getItem(`publicProfileAcquiredIds_${uid}`)
          const savedStudying = localStorage.getItem(`publicProfileStudyingIds_${uid}`)
          if (savedAcquired) this.selectedAcquiredIds = JSON.parse(savedAcquired)
          if (savedStudying) this.selectedStudyingIds = JSON.parse(savedStudying)
        } else {
          localStorage.removeItem(`publicProfileToken_${uid}`)
        }
      }
    },
    watch: {
      publicProfileDialog (val) {
        if (val && !this.publicToken) {
          this.selectedAcquiredIds = (this.$store.state.user.shikakuList || []).map(i => i.id).filter(Boolean)
          this.selectedStudyingIds = (this.$store.state.user.studyList || []).map(i => i.id).filter(Boolean)
        }
      },
    },
    computed: {
      ...mapState([
        'drawer',
        'darkMode',
      ]),
      version () {
        return versionData
      },
      publicUrl () {
        return `${BASE_URL}/profile/${this.publicToken}`
      },
      previewAcquired () {
        return (this.$store.state.user.shikakuList || [])
          .filter(item => this.selectedAcquiredIds.includes(item.id))
          .map(item => ({
            name: item.name || '',
            shutokubi: item.shutokubi || null,
          }))
      },
      previewStudying () {
        return (this.$store.state.user.studyList || [])
          .filter(item => this.selectedStudyingIds.includes(item.id))
          .map(item => ({
            name: item.name || '',
            shikenbi: item.shikenbi || null,
          }))
      },
    },
    methods: {
      toggleAcquired (id) {
        const idx = this.selectedAcquiredIds.indexOf(id)
        if (idx >= 0) this.selectedAcquiredIds.splice(idx, 1)
        else this.selectedAcquiredIds.push(id)
      },
      toggleStudying (id) {
        const idx = this.selectedStudyingIds.indexOf(id)
        if (idx >= 0) this.selectedStudyingIds.splice(idx, 1)
        else this.selectedStudyingIds.push(id)
      },
      logout () {
        firebase.auth()
          .signOut()
          .then(() => {
            this.$store.commit('RESET_USER')
            sessionStorage.clear()
            this.$router.push({ path: '/' })
          }).catch((error) => {
            console.error('Failed to logout.', error)
          })
      },
      changeTheme () {
        this.$vuetify.theme.dark = !this.$vuetify.theme.dark
        this.$store.commit('SET_DARK_MODE', this.$vuetify.theme.dark)
        /* ログイン済みユーザの場合Firebaseのデータを更新 */
        if (this.$store.state.user.uid) {
          funcSetDataToFirebase()
        }
      },
      syncAppData () {
        window.location.reload(true)
      },
      async enablePublicProfile () {
        this.publicLoading = true
        const uid = this.$store.state.user.uid
        const token = this.publicToken || uuidv4()
        const shikakuList = this.$store.state.user.shikakuList || []
        const studyList = this.$store.state.user.studyList || []
        const data = {
          acquired: shikakuList
            .filter(item => this.selectedAcquiredIds.includes(item.id))
            .map(item => ({
              name: item.name || '',
              shutokubi: item.shutokubi || null,
            })),
          studying: studyList
            .filter(item => this.selectedStudyingIds.includes(item.id))
            .map(item => ({
              name: item.name || '',
              shikenbi: item.shikenbi || null,
            })),
          uid,
        }
        await funcSetPublicProfile(token, data)
        localStorage.setItem(`publicProfileToken_${uid}`, token)
        localStorage.setItem(`publicProfileAcquiredIds_${uid}`, JSON.stringify(this.selectedAcquiredIds))
        localStorage.setItem(`publicProfileStudyingIds_${uid}`, JSON.stringify(this.selectedStudyingIds))
        this.publicToken = token
        this.publicLoading = false
      },
      async disablePublicProfile () {
        this.publicLoading = true
        const uid = this.$store.state.user.uid
        await funcDeletePublicProfile(this.publicToken)
        localStorage.removeItem(`publicProfileToken_${uid}`)
        this.publicToken = null
        this.publicLoading = false
      },
      async copyUrl () {
        await navigator.clipboard.writeText(this.publicUrl)
        this.copied = true
        setTimeout(() => { this.copied = false }, 2000)
      },
      ...mapMutations({
        setDrawer: 'SET_DRAWER',
      }),
    },
  }
</script>
